module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/23.519540d7.png";